'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import { styled, Flex } from '@acko-tech/building-blocks.ui.common'
import { Text } from '@acko-tech/building-blocks.ui.typography'

export const IllogicalFlowWrapper = styled(Flex)`
  box-sizing: border-box;
  background: #fff4c7;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-radius: 8px;
  margin: 20px 0px 0px 0px;
  display: ${(props) => (props.show ? 'flex' : 'none')};
`

export const IllogicalFlowLeftContent = styled(Flex)`
  flex-direction: column;
  width: 100%;
`

export const IllogicalFlowRightContent = styled(Flex)`
  width: auto;
`

export const IllogicalFlowText = styled(Text)`
  color: #0b0e34;
  font-size: 12px;
  margin: 3px 0px;
  font-weight: 700;
`

export const IllogicalFlowSubText = styled(Text)`
  font-weight: 500;
  font-size: 10px;
  line-height: 12px;
  color: #434f5a;
  margin: 3px 0px;
`

export const LoginButton = styled.button`
  font-weight: 600;
  font-size: 12px;
  line-height: 12px;
  padding: 6px 12px;
  box-sizing: border-box;
  width: 57px;
  height: 24px;
  border: 1px solid #434f5a;
  border-radius: 6px;
  background: transparent;
  display: flex;
  align-items: center;
  cursor: pointer;
`
